export default "__VITE_ASSET__VMRt4iCe__"